import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { ReportingReference } from '@principle-theorem/principle-core/interfaces';
import * as moment from 'moment-timezone';

export interface IReportBuilderDateRangeFormData {
  from: moment.Moment;
  to: moment.Moment;
  queryableTimestamp: ReportingReference;
}

export class ReportBuilderDateRangeForm extends TypedFormGroup<IReportBuilderDateRangeFormData> {
  constructor() {
    super({
      from: new TypedFormControl<moment.Moment>(moment().startOf('day'), [
        Validators.required,
      ]),
      to: new TypedFormControl<moment.Moment>(moment().endOf('day'), [Validators.required]),
      queryableTimestamp: new TypedFormControl<ReportingReference>(
        undefined,
        Validators.required
      ),
    });
  }
}
